export default "__VITE_ASSET__BKesdXL8__"